module.exports = __webpack_public_path__ + "img/watchList.00906022.svg";